import gql from 'graphql-tag';

import userFragment from './user-fragment';

export default gql`
  query findByCodeForActivationUserQuery($codeForActivation: String!) {
    findByCodeForActivationUserQuery(codeForActivation: $codeForActivation) {
      ...UserFragment
    }
  }
  ${userFragment}
`;
